import "./App.css";
import SmoothScroll from "./components/site/SmoothScroll";
import Nav from "./components/site/Nav";
import ChapterRail from "./components/site/ChapterRail";
import Hero from "./components/site/Hero";
import Ticker from "./components/site/Ticker";
import Incident from "./components/site/Incident";
import Evidence from "./components/site/Evidence";
import Witness from "./components/site/Witness";
import Instrumentation from "./components/site/Instrumentation";
import Hypotheses from "./components/site/Hypotheses";
import RootCause from "./components/site/RootCause";
import Footer from "./components/site/Footer";

function App() {
  return (
    <SmoothScroll>
      <div className="App relative bg-[#0f1724] min-h-screen text-white antialiased">
        <div className="noise-overlay" />
        <Nav />
        <ChapterRail />
        <main>
          <Hero />
          <Ticker />
          <Incident />
          <Evidence />
          <Witness />
          <Instrumentation />
          <Hypotheses />
          <RootCause />
        </main>
        <Footer />
      </div>
    </SmoothScroll>
  );
}

export default App;
